import styled from 'styled-components';
import { Type } from '@spotify-internal/encore-creator-web';
import { screenMdMin } from '@spotify-internal/encore-foundation';

export const TextWithDesktopLineBreak = styled(Type).attrs({
  forwardedAs: 'span',
})`
  &::before {
    content: ' ';
  }

  @media (min-width: ${screenMdMin}) {
    &::before {
      content: '\\A';
      white-space: pre;
    }
  }
`;
